import { LogOut } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import Button from '../ui/Button';

const OnboardingHeader = ({ forceDark = false, onSignOut, signOutDisabled = false }) => {
  const { preference } = useTheme();
  const isLight = !forceDark && preference === 'light';
  const signOutButtonClassName = 'onboarding-sign-out';

  return (
    <div className="onboarding-header">
      <img
        src={`${process.env.PUBLIC_URL}/${isLight ? 'Vylo - Light BG.svg' : 'Vylo - Dark BG.svg'}`}
        alt="Vylo"
        className="h-10 w-auto max-w-[160px]"
      />
      <div className="flex min-w-0 justify-end">
        {onSignOut ? (
          <Button
            type="button"
            variant="unstyled"
            size="none"
            onClick={onSignOut}
            disabled={signOutDisabled}
            title="Sign out"
            aria-label="Sign out"
            className={`inline-flex h-9 min-w-9 items-center justify-center gap-2 rounded-full border px-2 text-sm font-semibold transition disabled:cursor-wait disabled:opacity-60 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 sm:px-3 ${signOutButtonClassName}`}
          >
            <LogOut className="h-4 w-4 shrink-0" />
            <span className="sr-only sm:not-sr-only">Sign out</span>
          </Button>
        ) : null}
      </div>
    </div>
  );
};

export default OnboardingHeader;
